/** @module ProductSpec/SizeChart/IncrementController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/ActionView",
    "csi/comm/PostRequest",
	"csi/def",
	"csi/action/Controller",
	"csi/xml"

], function(declare,lang,_,ActionView,PostRequest,def,Controller,xml) {
	const CSS_ATTR = "_CSS";

	/**
	 * This module is action controller for
	 * ProductSpec.xml
	 * Node = SizeChartRevision
	 * Heading Id="Group"
	 * View Widget = "ProductSpec/SizeChart/IncrementView"
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Increment" tooltip "Edit"
	 */

	return declare(Controller, {

		/**
		 * @override
		 * Initialize the view
		 */
		getActionView: function(vr) {
			const node = this.getNode() || this.m_cache.getNode(this.getParent().SizeChartSubSizeRanges[0]);
			const defView = def.getNodeViewDef(node, "Increment");

			return new ActionView(this, defView, node);
		},


		toWriter: function() {

			const call = this.inherited(arguments); // csi/xml/CallMethod

			const {
				newIncrement,
				changeProductGroup,
				newProductGroup,
				maintainBaseSize,
				maintainTolerances,
				maintainDimensions,
				maintainIncrements
			} = this.popupView;

			call.addParameter("URL", xml.ATTR_REF, this.getParentURL());
			call.addParameter("Increment", xml.ATTR_REF, newIncrement);
			call.addParameter("MaintainBaseSize", xml.ATTR_BOOLEAN, maintainBaseSize);
			call.addParameter("MaintainDimensions", xml.ATTR_BOOLEAN, maintainDimensions);
			call.addParameter("MaintainIncrements", xml.ATTR_BOOLEAN, maintainIncrements);
			if (changeProductGroup){
				call.addParameter("ProductGroup", xml.ATTR_REF, newProductGroup);
				call.addParameter("MaintainTolerances", xml.ATTR_BOOLEAN, maintainTolerances);
			}
			// Specify subrange for composite size chart
			if (this.getParent().SizeChartSubSizeRanges.length > 1){
				call.addParameter("SubRange", xml.ATTR_REF, this.getNodeURL());
			}
		}

	});
});